import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';

const items = [
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Noticias TNO (noticiero)',
    description:
      'Menciones y cintillos semanales con Sol Vargas: tips de salud visual, campañas de exámenes y servicios Berlud en formato informativo de alto prestigio.',
    price: 55,
    note: 'Desde $55/mes (Bronce: 1 mención) · Plata/Oro: cintillo semanal',
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 4V2a1 1 0 011-1h8a1 1 0 011 1v2m-9 0h10m-10 0a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2M9 12l2 2 4-4" />
      </svg>
    ),
    title: 'Rotativa Radio Visual',
    description:
      'Micros de 30–45 segundos en la señal 24/7. Plan Bronce: 6/día · Plata y Oro: 12/día (hasta 360 impactos mensuales).',
    price: 85,
    note: 'Desde $85/mes (6 impactos/día)',
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
    ),
    title: 'TNO Digest (más artículos)',
    description:
      'Artículos SEO en tnonetwork.com: cuidado de la vista, monturas, lentes progresivos, exámenes y promociones Berlud. Bronce 1 · Plata 2 · Oro 4 al mes.',
    price: 45,
    note: 'Por artículo · paquetes integrados en cada plan',
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Inserts en redes',
    description:
      'Logo, claqueta y cintillo en Reels, Shorts y clips derivados de programas TNO. Bronce 2 · Plata 6 · Oro 12 inserts mensuales + difusión en cuentas oficiales.',
    price: 20,
    note: 'Por insert · escala según plan',
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Micros en video (Plata y Oro)',
    description:
      'Estudio TNO, piezas con fotos/catálogo de Berlud, motion, derivados de Digest o entrevista con vocero. Plata: 2/mes · Oro: 4/mes. Ver formatos en la sección de propuesta de valor.',
    price: 45,
    note: 'Sin grabación en sucursal de la óptica',
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
    title: 'En Sintonía con tu Salud (Plan Oro)',
    description:
      'Bloque mensual con la Dra. Grecia Andreina: prevención, chequeos visuales y bienestar. Berlud como aliado de salud en antena.',
    price: 80,
    note: 'Exclusivo Plan Oro',
  },
];

const ContenidoParaMarcas = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          gutterBottom
          color="primary"
          align="center"
        >
          Inventario de comercialización
        </Typography>
        <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
          Noticiero, rotativa, Digest e inserts
        </Typography>
        <Typography variant="h6" component="p" color="textSecondary" align="center" sx={{ maxWidth: 680, mx: 'auto' }}>
          Cada línea del plan suma presencia en un punto del recorrido del cliente: informarse (noticiero), recordar (rotativa),
          buscar en Google (Digest) y compartir en redes (inserts). Los micros de Plata y Oro se producen en estudio TNO o con
          el material gráfico que nos comparta la marca — sin necesidad de grabar en la óptica.
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={i} data-aos="fade-up">
            <Box
              component={Card}
              height="100%"
              variant="outlined"
              sx={{
                transition: 'all .2s ease-in-out',
                '&:hover': { boxShadow: 4, borderColor: theme.palette.primary.main },
              }}
            >
              <CardContent>
                <Box
                  component={Avatar}
                  variant="rounded"
                  sx={{
                    width: 56,
                    height: 56,
                    mb: 2,
                    bgcolor: `${theme.palette.primary.light}33`,
                    color: theme.palette.primary.dark,
                  }}
                >
                  {item.icon}
                </Box>
                <Typography variant="h6" fontWeight={700} gutterBottom color="primary">
                  {item.title}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                  {item.description}
                </Typography>
                <Typography variant="h6" fontWeight={700} color="primary">
                  desde ${item.price}
                </Typography>
                <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 0.5 }}>
                  {item.note}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ContenidoParaMarcas;
